const React = require("react");
const DevNavSection = require("../DevNavSection");
const styles = require("../styles/DevPanels.css");

const DevNavigationPages = function() {
	const pages = [
		{
			href: "/dev/canvasmath/",
			label: "CanvasMath playground",
		},
		{
			href: "/dev/canvasmath/#clear",
			label: "CanvasMath playground + clear remembered code",
		},
		{
			href: "/dev/comparisonreporter/",
			label: "Comparison test reporter",
		},
		{
			href: "/dev/previews/",
			label: "Dev problem browser",
		},
		{
			href: "/school/classroom/dev/engineTester/",
			label: "Dev engine tester",
		},
		{
			href: "/dev/baeplay",
			label: "BAE Play button tester",
		},
		{
			href: "/dev/diagram/",
			label: "Diagram playground",
		},
		{
			href: "/dev/animation/",
			label: "Animation playground",
		},
		{
			href: "/dev/endpoints/",
			label: "PostBanda (endpoint testing tool)",
		},
		{
			href: "/dev/classwallettoolkit/",
			label: "ClassWallet toolkit",
		},
		{
			href: "/dev/printablepreview/",
			label: "Printable Preview Page",
		},
		{
			href: "/dev/testserverviewer/",
			label: "Test server viewer",
		},
		{
			href: "/dev/level-overview",
			label: "Level overview",
		},
	];
	return (
		<DevNavSection heading="Other pages">
			{pages.map(page => (
				<div key={page.href}>
					<a className={styles.linkExt} href={page.href}>
						{page.label}
					</a>
				</div>
			))}
		</DevNavSection>
	);
};

module.exports = DevNavigationPages;
